module.exports = __webpack_public_path__ + "img/require-success-icon.4b62c031.png";